// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4818":"c17145b1","5216":"318875b4"}[chunkId] + ".chunk.css";
};